import styles from './ChallengesList.module.scss';
import { ChallengesTable } from './components/ChallengesTable/ChallengesTable';
import React, { useState } from 'react';
import { useGetChallengesList } from '../../hooks/useGetChallengesList';
import { useGetActions } from '../../hooks/useGetActions';
import { Paging } from '../Shared/Paging/Paging';
import { Loader } from '../Shared/Loader/Loader';
import { PAGE_OPTIONS } from '../../constants';

export const ChallengesList = () => {
    const [pageSize, setPageSize] = useState(PAGE_OPTIONS[0]);
    const [pageNumber, setPageNumber] = useState(1);

    const {
        data,
        isLoading: isLoadingChallenges,
        refetch,
    } = useGetChallengesList({
        pageSize,
        pageNumber,
    });

    const { data: actions, isLoading: isLoadingActions } = useGetActions();
    const isLoading = isLoadingChallenges || isLoadingActions;

    const changePageSize = (size: number) => {
        setPageSize(size);
        setPageNumber(1);
    };

    return (
        <div className={styles.container}>
            <div className={styles.title}>Challenges</div>
            <div className={styles.row}></div>

            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <ChallengesTable data={data?.entities} actions={actions} refetch={refetch} />
                    <Paging
                        totalRecords={data?.total ?? 1}
                        pageSize={pageSize}
                        pageNumber={pageNumber}
                        changePage={setPageNumber}
                        changePageSize={changePageSize}
                    />
                </>
            )}
        </div>
    );
};
